import { Component, OnInit } from '@angular/core';
import {NextNotificationService} from '../../../core/services/impl/next-notification.service';
import {FeaturedProductsService} from '../../services/featured-products.service';
import {NotificationStatusConfig} from '../../../core/models/notification';
import {FeaturedProductTileConfig} from '../../models/featured-product';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FeaturedProductsConfig} from '../../../core/configs/featured-products-config';

@Component({
  selector: 'app-notification-wrapper',
  templateUrl: './notification-wrapper.component.html'
})
export class NotificationWrapperComponent implements OnInit {

  featuredProducts: FeaturedProductTileConfig[];

  get isLoadingMode(): boolean {
    return this.notificationService.loading;
  }

  get notificationData(): NotificationStatusConfig {
    return this.notificationService.notificationStatusConfig;
  }

  get notificationVisible(): boolean {
    return !this.isLoadingMode && isNotNullOrUndefined(this.notificationData);
  }

  get productsVisible(): boolean {
    return isNotNullOrUndefined(this.notificationData) ? this.notificationData.productsVisible : false;
  }

  get footerVisible(): boolean {
    return isNotNullOrUndefined(this.notificationData) ? this.notificationData.footerVisible : false;
  }

  constructor(public notificationService: NextNotificationService,
              private featuredProductsService: FeaturedProductsService) {
  }

  ngOnInit(): void {
    if (this.notificationService.nextNotification) {
      this.initFeaturedProducts();
      this.notificationService.init();
    }
  }

  private initFeaturedProducts(): void {
    const config = new FeaturedProductsConfig();
    const tiles = config.createTilesConfig().filter(tile => !tile.disabled);
    this.featuredProductsService.init(tiles, config.createIconsConfig(), config.createUrlParamsConfig());
    this.featuredProducts = this.featuredProductsService.featuredProductTiles;
  }

}
